import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createPhoneUser } from '../../services/authService';
import './CreateUserPage.css';

function CreateUserPage() {
  const [phoneNum, setPhoneNum] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();

  const handleCreateUser = async () => {
    if (!phoneNum || !password) {
      setMessage('请输入手机号和密码');
      setIsError(true);
      return;
    }

    try {
      await createPhoneUser(phoneNum, password);
      
      setMessage('用户创建成功！');
      setIsError(false);
      
      // 延迟跳转回登录页
      setTimeout(() => {
        navigate('/');
      }, 1500);

    } catch (error) {
      console.error('Create user error:', error);
      // 提取错误信息
      const errorMsg = error.message || '未知错误';
      setMessage(`创建失败: ${errorMsg}`);
      setIsError(true);
    }
  };

  return (
    <div className="create-user-container">
      <div className="create-user-card">
        <h1 className="create-user-title">创建新用户</h1>
        
        <div className="input-group">
          <label className="input-label">手机号</label>
          <input
            type="text"
            className="create-user-input"
            value={phoneNum}
            onChange={(e) => setPhoneNum(e.target.value)}
            placeholder="请输入手机号"
          />
        </div>

        <div className="input-group">
          <label className="input-label">密码</label>
          <input
            type="password"
            className="create-user-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="请输入密码"
          />
        </div>

        {message && (
          <div className={`message-box ${isError ? 'error' : 'success'}`}>
            {message}
          </div>
        )}

        <button 
          onClick={handleCreateUser}
          className="btn-create"
        >
          创建用户
        </button>

        <button 
          onClick={() => navigate('/')}
          className="btn-back-login"
        >
          返回登录
        </button>
      </div>
    </div>
  );
}

export default CreateUserPage;
